export type LtiTargetFactInput = {
  target_lti?: number | null;
  ltip_amount?: number | null;
  reliability_score?: number | null;
};

export type LtiTargetFactSummary = {
  count: number;
  targetAvg: number;
  factAvg: number;
  /** factSum / targetSum. 0, если сумма target равна нулю. */
  ratio: number;
  avgReliability: number;
};

function asMoney(value: number | null | undefined): number {
  return value != null && Number.isFinite(value) ? value : 0;
}

/** Среднее по всем датакейсам группы. Пустой LTI входит как 0. */
export function summarizeLtiTargetFact(records: LtiTargetFactInput[]): LtiTargetFactSummary {
  const count = records.length;
  let targetSum = 0;
  let factSum = 0;
  let reliabilitySum = 0;
  for (const record of records) {
    targetSum += asMoney(record.target_lti);
    factSum += asMoney(record.ltip_amount);
    const score = record.reliability_score;
    reliabilitySum += score != null && Number.isFinite(score) ? score : 0;
  }
  return {
    count,
    targetAvg: count > 0 ? targetSum / count : 0,
    factAvg: count > 0 ? factSum / count : 0,
    ratio: targetSum > 0 ? factSum / targetSum : 0,
    avgReliability: count > 0 ? reliabilitySum / count : 0,
  };
}

export function formatLtiMillions(value: number): string {
  const mln = value / 1_000_000;
  const oneDecimal = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(mln);
  const digits = oneDecimal === '0,0' && mln > 0 ? 2 : 1;
  const formatted = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(mln);
  return `${formatted} млн ₽`;
}

export function formatLtiRatio(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}
